import type { I18nKey } from './en';

// Dutch strings — typed against the English key set so a missing entry fails
// `tsc`, not a user in Breda.
export const nl: Record<I18nKey, string> = {
  start: 'Start',
  callflow: 'Callflow',
  departments: 'Afdelingen',
  people: 'Medewerkers',
  hours: 'Openingstijden',
  structure: 'Volledige structuur',
  about: 'Over dit overzicht',
  navigation: 'Navigatie',
  section: 'Onderdeel',
  search: 'Zoek afdeling of medewerker',
  noResults: 'Geen resultaten',
  resultMenu: 'Menu',
  resultDepartment: 'Afdeling',
  resultPerson: 'Medewerker',
  language: 'Taal',
  print: 'Afdrukken',
  edit: 'Bewerken',
  diagram: 'Diagram',
  guide: 'Wegwijzer',
  outline: 'Overzicht',
  openInBrowser: 'Openen in browser',
  openInTeams: 'Openen in Teams',
  location: 'Locatie',
  mainNumber: 'Algemeen nummer',
  scopeText: 'Overzicht van het telefoonmenu achter het algemene nummer.',
  snapshot: 'Momentopname',
  lastUpdated: 'Laatst bijgewerkt',
  syncedFromTeams: 'Gesynchroniseerd vanuit Teams',
  importedFromTeams: 'Geïmporteerd uit Teams',
  unknown: 'Onbekend',
  yes: 'Ja',
  no: 'Nee',
  seconds: 'seconden',
  minutes: 'minuten',
  calls: 'oproepen',
  openNow: 'Het algemene nummer is nu geopend',
  closedNow: 'Het algemene nummer is nu gesloten',
  statusUnknown: 'Openingsstatus onbekend — geen tijden ingesteld',
  availableNow: 'Nu bereikbaar',
  notAvailableNow: 'Nu niet bereikbaar',
  hoursUnknown: 'Tijden onbekend',
  nextChange: 'Volgende wijziging',
  opensAt: 'opent',
  closesAt: 'sluit',
  timeZone: 'Tijden in {tz}',
  today: 'vandaag',
  tomorrow: 'morgen',
  heroTitle: 'Vind snel de juiste afdeling',
  heroSubtitle: 'Volg het telefoonmenu stap voor stap',
  heroText: 'Kies dezelfde toetsen die een beller hoort. Elke stap laat zien wie opneemt, wanneer de afdeling bereikbaar is en wat een beller hoort.',
  statsMenus: 'Menu’s',
  statsDepartments: 'Afdelingen',
  statsAgents: 'Geconfigureerde medewerkers',
  statsGroups: 'Groepen',
  quickTitle: 'Direct naar een afdeling',
  quickIntro: 'Open een afdeling om de belroute, medewerkers en wachtrij-instellingen te bekijken.',
  howTitle: 'Zo gebruikt u dit overzicht',
  how1: 'Start bij het algemene nummer.',
  how2: 'Kies dezelfde taal en menutoets als tijdens een echte oproep.',
  how3: 'Open de eindbestemming om te zien wie de oproep ontvangt en wat er gebeurt als niemand opneemt.',
  startCallflow: 'Start de callflow',
  callflowTitle: 'Interactieve callflow',
  callflowIntro: 'Gebruik de knoppen of de cijfers 0 tot en met 9 op uw toetsenbord.',
  restart: 'Opnieuw beginnen',
  back: 'Eén stap terug',
  chooseOption: 'Kies een optie',
  noOptions: 'Dit menu heeft geen opties.',
  menuChoice: 'Menukeuze',
  autoAttendant: 'Telefoonmenu',
  callQueue: 'Afdeling',
  terminal: 'Eindpunt',
  thenRoutesTo: 'Gaat daarna naar',
  operator: 'Telefoniste',
  afterHours: 'Buiten deze uren',
  afterHoursDisconnect: 'De oproep wordt verbroken.',
  afterHoursRoutes: 'De oproep gaat naar',
  parentHours: 'De bovenliggende menu’s bepalen de uiteindelijke bereikbaarheid.',
  businessHours: 'Bereikbaarheid',
  ownHours: 'Eigen ingestelde uren',
  effectiveHours: 'Effectieve uren via het algemene nummer',
  inherited: 'Volgt het algemene nummer',
  prompt: 'Wat een beller hoort',
  greeting: 'Begroeting',
  menuPrompt: 'Menutekst',
  weekday: 'Dag',
  period: 'Tijden',
  closed: 'Gesloten',
  always: 'Hele dag',
  holidays: 'Feestdagen en sluitingen',
  noHolidays: 'Geen feestdagen ingesteld',
  departmentTitle: 'Afdelingen',
  departmentIntro: 'Alle eindbestemmingen die vanuit het algemene nummer bereikbaar zijn.',
  all: 'Alle',
  withAgents: 'Met medewerkers',
  withoutAgents: 'Zonder medewerkers',
  filterHere: 'Filter binnen deze pagina',
  viewDepartment: 'Afdeling bekijken',
  routes: 'Belroutes',
  route: 'Belroute',
  routeHours: 'Bereikbaarheid via deze route',
  copyRoute: 'Route kopiëren',
  copied: 'Gekopieerd',
  noRoute: 'Niet bereikbaar via het menu',
  queueTeam: 'Medewerkers van deze afdeling',
  noAgents: 'Er zijn geen medewerkers aan deze afdeling gekoppeld.',
  agentsCount: 'medewerkers',
  agentsOf: '{available} van {total} beschikbaar',
  optedOut: 'afgemeld',
  call: 'Bellen',
  callDepartment: 'Deze afdeling bellen',
  email: 'E-mail',
  handling: 'Afhandeling van oproepen',
  distribution: 'Verdeling',
  presence: 'Beschikbaarheidsstatus gebruiken',
  ringTime: 'Aanbiedtijd per medewerker',
  optOut: 'Medewerkers mogen zichzelf afmelden',
  conferenceMode: 'Conferentiemodus',
  queueLanguage: 'Taal',
  overflow: 'Wachtrij vol',
  timeout: 'Maximale wachttijd',
  noAgent: 'Geen medewerkers beschikbaar',
  limit: 'Limiet',
  appliesTo: 'Van toepassing op',
  allCalls: 'Alle oproepen',
  newCalls: 'Nieuwe oproepen',
  after: 'Daarna',
  sharedVoicemail: 'Gedeelde voicemail',
  disconnect: 'Verbinding verbreken',
  forwardTo: 'Doorschakelen naar',
  voicemail: 'Voicemail',
  keepInQueue: 'Beller blijft in de wachtrij',
  transcription: 'Transcriptie',
  playedMessage: 'Afgespeeld bericht',
  music: 'Wachtmuziek',
  defaultMusic: 'Standaard wachtmuziek',
  customMusic: 'Eigen muziek',
  welcomeGreeting: 'Welkomstbegroeting',
  callback: 'Terugbeloptie',
  callbackKey: 'Toets',
  offerAfter: 'Aangeboden na',
  offerWhenWaiting: 'of zodra er {n} oproepen wachten',
  serviceLevel: 'Servicenorm',
  noCallback: 'Geen terugbeloptie',
  voicemailGroups: 'Voicemail en terugbeloptie',
  group: 'Groep',
  members: 'Ontvangers',
  loadingMembers: 'Leden laden…',
  membersFailed: 'Leden konden niet worden geladen',
  noMembers: 'Geen leden',
  peopleTitle: 'Medewerkers per afdeling',
  peopleIntro: 'Dit zijn de medewerkers die in Teams op iedere afdeling zijn ingesteld.',
  person: 'Medewerker',
  department: 'Afdeling',
  active: 'Neemt op',
  noPeople: 'Geen medewerkers gevonden voor dit filter.',
  hoursTitle: 'Openingstijden van de menu’s',
  hoursIntro: 'Een afdeling is alleen bereikbaar als ieder menu in de gekozen route open is.',
  structureTitle: 'Volledige callflow',
  structureIntro: 'Klik op een onderdeel om het interactieve pad of de afdelingsgegevens te openen.',
  aboutTitle: 'Over dit overzicht',
  aboutText: 'Dit overzicht wordt gemaakt vanuit de Microsoft Teams telefonie-instellingen. Structuur en instellingen komen uit de laatste export of synchronisatie; de openingsstatus en beschikbaarheid worden live berekend.',
  source: 'Bron',
  exportTaken: 'Teams-export gemaakt op',
  autoSync: 'Automatische synchronisatie',
  manualImport: 'Handmatige import',
  documentedBy: 'Beheerd door',
  simultaneous: 'Gelijktijdig naar alle medewerkers',
  serial: 'Na elkaar volgens de ingestelde volgorde',
  roundRobin: 'Om de beurt',
  longestIdle: 'Langst beschikbare medewerker eerst',
  presenceAvailable: 'Beschikbaar',
  presenceBusy: 'Bezet',
  presenceAway: 'Afwezig',
  presenceOffline: 'Offline',
  presenceDnd: 'Niet storen',
  presenceInCall: 'In gesprek',
  presenceInMeeting: 'In een vergadering',
  presenceUnknown: 'Status onbekend',
  presenceNotEnabled: 'Live beschikbaarheid is niet ingeschakeld voor deze organisatie. Vraag de beheerder om de Presence.Read.All-machtiging te verlenen.',
  presenceGrant: 'Machtiging verlenen (beheerder)',
  presenceUnavailable: 'Live beschikbaarheid is tijdelijk niet beschikbaar.',
  audioListen: 'Beluisteren',
  audioStop: 'Stop',
  audioNotUploaded: 'Opname nog niet geüpload',
  audioFile: 'Audiobestand',
  ttsListen: 'Beluisteren (browserstem)',
  ttsUnavailable: 'Spraak is niet beschikbaar in deze browser',
  textToSpeech: 'Tekst naar spraak',
  monday: 'Maandag', tuesday: 'Dinsdag', wednesday: 'Woensdag', thursday: 'Donderdag', friday: 'Vrijdag', saturday: 'Zaterdag', sunday: 'Zondag',
  mon: 'Ma', tue: 'Di', wed: 'Wo', thu: 'Do', fri: 'Vr', sat: 'Za', sun: 'Zo',
  langNl: 'Nederlands',
  langEn: 'English',
  footer: 'Telefoonmenu',
  noLocations: 'Er zijn geen telefoonmenu’s met u gedeeld',
  selectLocation: 'Kies een locatie',
};
